import React from "react";
import { chakra } from "@chakra-ui/react";
import images from "../../imageConstant";
export const Logo = (props) => (
  <chakra.img
    src={images.logo}
    alt="logo"
    className="aspect-auto w-32 "
    {...props}
  />
);
